// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2bW2X","title":"ClientInsurance_title__2hJRR","itemText":"ClientInsurance_itemText__3x-1l"};